import api from "./api";

export const getAllPartners = async () => {
  try {
    const response = await api.get('/master/partners');
    return response.data;
  } catch (error) {
    console.error("There was an error fetching partners:", error);
    throw error;
  }
};

export const getPartnerById = async (id) => {
  try {
    const response = await api.get(`/master/partners/${id}`);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching partner:", error);
    throw error;
  }
};

export const createPartner = async (data) => {
  try {
    const response = await api.post('/master/partners', data);
    return response.data;
  } catch (error) {
    console.error("There was an error creating partner:", error);
    throw error;
  }
};

export const updatePartner = async (data, id) => {
  try {
    const response = await api.put(`/master/partners/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("There was an error updating partner:", error);
    throw error;
  }
};

export const updatePartnerStatus = async (id, status) => {
  try {
    const response = await api.patch(`/master/partners/${id}/status`, { status });
    return response.data;
  } catch (error) {
    console.error("There was an error updating partner status:", error);
    throw error;
  }
};

export const resetPartnerAdminPassword = async (id, password) => {
  try {
    const response = await api.patch(`/master/partners/${id}/admin-password`, { password });
    return response.data;
  } catch (error) {
    console.error("There was an error resetting the partner admin password:", error);
    throw error;
  }
};

export const getAllClientRequests = async (params) => {
  try {
    const response = await api.get('/master/client-requests', { params });
    return response.data;
  } catch (error) {
    console.error("There was an error fetching client requests:", error);
    throw error;
  }
};

export const getClientRequestById = async (id) => {
  try {
    const response = await api.get(`/master/client-requests/${id}`);
    return response.data;
  } catch (error) {
    console.error("There was an error fetching client request:", error);
    throw error;
  }
};

export const approveClientRequest = async (id) => {
  try {
    const response = await api.post(`/master/client-requests/${id}/approve`);
    return response.data;
  } catch (error) {
    console.error("There was an error approving client request:", error);
    throw error;
  }
};

export const rejectClientRequest = async (id, rejectionReason) => {
  try {
    const response = await api.post(`/master/client-requests/${id}/reject`, { rejection_reason: rejectionReason });
    return response.data;
  } catch (error) {
    console.error("There was an error rejecting client request:", error);
    throw error;
  }
};

export const getPendingRequestsCount = async () => {
  try {
    const response = await api.get('/master/client-requests', { params: { status: 'pending' } });
    const data = response.data;
    if (data.meta) return data.meta.total;
    if (Array.isArray(data)) return data.length;
    if (Array.isArray(data.data)) return data.data.length;
    return 0;
  } catch (error) {
    console.error("There was an error fetching pending requests count:", error);
    throw error;
  }
};
